import React from 'react';
import ChevronDropdownIcon from 'app/assets/figma/slideout/chevron-dropdown-old.svg';

interface DropdownChevronIconProps {
  className?: string;
}

/** Standard dropdown chevron — same asset as slideout header / phase row (9×8). */
export const DropdownChevronIcon: React.FC<DropdownChevronIconProps> = ({
  className = ''
}) => {
  return (
    <span
      className={className}
      aria-hidden="true"
      style={{
        width: 9,
        height: 8,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <img
        src={ChevronDropdownIcon}
        alt=""
        width={9}
        height={8}
        style={{ display: 'block' }}
      />
    </span>
  );
};
